import APIClient from 'wootils/esm/shared/apiClient';

const listsDefaultPaginationCount = 20;

class AppAPI extends APIClient {
  constructor($http, $q, appConfiguration) {
    'ngInject';

    super(
      appConfiguration.api.url,
      appConfiguration.api.endpoints,
      (url, options) => this._fetch(url, options),
    );

    this.$http = $http;
    this.$q = $q;
    this.appConfiguration = appConfiguration;
  }
  login(email, password) {
    return this.post(this.endpoint('auth.login'), { email, password });
  }
  rememberPassword(email, referer) {
    return this.post(this.endpoint('auth.remember'), { email, referer });
  }
  referrer(code, ref) {
    return this.get(this.endpoint('auth.referrer', { code, ref }));
  }
  resetPassword(code, newPassword, confirmNewPassword) {
    return this.post(this.endpoint('auth.reset'), {
      code,
      newPassword,
      confirmNewPassword,
    });
  }
  update(
    name,
    email,
    currentEmail,
    currentPassword,
    newPassword,
    confirmNewPassword,
  ) {
    return this.post(this.endpoint('user.update'), {
      name,
      email,
      currentEmail,
      currentPassword,
      newPassword,
      confirmNewPassword,
    });
  }
  newUser(name, email, scopeId) {
    return this.post(this.endpoint('users.new'), {
      name,
      email,
      scopeId,
    });
  }
  reactivateUser(email) {
    return this.post(this.endpoint('users.reactivate'), { email });
  }
  importUser(email) {
    return this.post(this.endpoint('users.import'), { email });
  }
  editUser(userId, name, email) {
    return this.put(this.endpoint('users.edit', { userId }), {
      name,
      email,
    });
  }
  deleteUser(userId) {
    return this.delete(this.endpoint('users.delete', { userId }));
  }
  removeUserAccess(userId) {
    return this.delete(this.endpoint('users.removeAccess', { userId }));
  }
  user(userId) {
    return this.get(this.endpoint('users.byId', { userId }));
  }
  users(page, count = listsDefaultPaginationCount, search) {
    const parameters = { page, count };
    if (search) {
      parameters.search = search;
    }

    return this.get(this.endpoint('users.list', parameters));
  }
  permissionsForBrand(userId, brandId) {
    return this.get(this.endpoint('users.permissions.brand', {
      userId,
      brandId,
    }));
  }
  rolesForBrand(userId, brandId, scopeId) {
    return this.get(this.endpoint('users.roles', {
      userId,
      brandId,
      scopeId,
    }));
  }
  brand(brandId) {
    return this.get(this.endpoint('brands.byId', { brandId }));
  }
  brandPermissions(brandIds) {
    return this.post(this.endpoint('brands.permissions'), { brandIds });
  }
  brandAdminSettings(brandId) {
    return this.get(this.endpoint('brands.adminSettings', { brandId }));
  }
  saveBrandAdminSettings(brandId, userIds, permissionIds) {
    return this.post(this.endpoint('brands.adminSettings', { brandId }), {
      userIds,
      permissionIds,
    });
  }
  userBrandAdminSettings(userId) {
    return this.get(this.endpoint('users.brandAdminSettings', { userId }));
  }
  saveUserBrandAdminSettings(userId, brandIds) {
    return this.post(this.endpoint('users.brandAdminSettings', { userId }), {
      brandIds,
    });
  }
  brands(page, count = listsDefaultPaginationCount, search) {
    const parameters = { page, count };
    if (search) {
      parameters.search = search;
    }
    return this.get(this.endpoint('brands.list', parameters));
  }
  appRoles() {
    return this.get(this.endpoint('permissions.appRoles'));
  }
  scopesWithPermissions(brandFacingOnly = false) {
    return this.get(this.endpoint('permissions.all', {
      brandFacingOnly,
    }));
  }
  scopes() {
    return this.get(this.endpoint('permissions.scopes'));
  }
  scope(scopeId) {
    return this.get(this.endpoint('permissions.scope', { scopeId }));
  }
  roles(scopeId) {
    return this.get(this.endpoint('permissions.roles', { scopeId }));
  }
  role(roleId) {
    return this.get(this.endpoint('permissions.role', { roleId }));
  }
  savePermissions(userIds, brandIds, allowedIds, deniedIds, scopeId) {
    return this.post(this.endpoint('permissions.save.brands'), {
      userIds,
      brandIds,
      allowedIds,
      deniedIds,
      scopeId,
    });
  }
  revokePermissions(userIds, brandIds, scopeId) {
    return this.post(this.endpoint('permissions.revoke.brands'), {
      userIds,
      brandIds,
      scopeId,
    });
  }
  changeUserRole(userId, roleId) {
    return this.get(this.endpoint('permissions.save.app', { userId, roleId }));
  }
  getUserActivities(userId, options = {}) {
    return this.post(this.endpoint('activities.search'), { userId, options });
  }
  getUserActivitiesDownloadURL(userId) {
    return this.endpoint(
      'activities.download',
      {
        token: this.authorizationToken,
        userId,
      },
    );
  }
  fetch(options) {
    return super.fetch(options)
    .then(({ data }) => data.data);
  }
  _fetch(url, options = {}) {
    const req = Object.assign({}, { url }, options);
    const { body } = req;
    if (body) {
      delete req.body;
      req.data = body;
    }

    return this.$http(req)
    .catch((errorResponse) => {
      let newErrorResponse;
      if (
        errorResponse.data &&
        errorResponse.data.data &&
        errorResponse.data.data.error
      ) {
        newErrorResponse = Object.assign(
          { status: errorResponse.status },
          errorResponse.data.data,
        );
      } else {
        newErrorResponse = errorResponse;
      }

      return this.$q.reject(newErrorResponse);
    });
  }
}

export default AppAPI;
